export const ISSUED_TICKET_STRINGS: Record<string, [string, string, string]> = {
  'issued.created': ['票券已建立', 'Tickets issued', 'チケットを発行しました'],
  'issued.useQr': [
    '請使用下方登船 QR。',
    'Use the QR code below to board.',
    '下のQRコードでご乗船ください。',
  ],
  'issued.summary': ['購買摘要', 'Purchase summary', '購入内容'],
  'issued.count': ['共 {count} 張票券', '{count} tickets in total', 'チケット合計 {count} 枚'],
  'issued.index': [
    '第 {number}／{count} 張票券',
    'Ticket {number} of {count}',
    'チケット {number}／{count}',
  ],
  'issued.previous': ['上一張', 'Previous ticket', '前のチケット'],
  'issued.next': ['下一張', 'Next ticket', '次のチケット'],
  'issued.unavailable': [
    '票券資料暫時無法載入，請重試或洽服務人員。',
    'Ticket unavailable. Retry or ask staff.',
    'チケットを読み込めません。再試行するかスタッフにお尋ねください。',
  ],
  'issued.empty': [
    '尚未取得票券，請洽服務人員確認訂單。',
    'No tickets received. Ask staff to check your order.',
    'チケットが取得できません。スタッフに注文をご確認ください。',
  ],
  'issued.keep': [
    '每張票券有獨立 QR Code，請分別保存。',
    'Each ticket has its own QR code. Save every ticket.',
    'チケットごとにQRコードが異なります。すべて保存してください。',
  ],
};
